import SEO from '../components/SEO';
import HeroSection from '../components/HeroSection';
import Features from '../components/home/Features';
import About from '../components/home/About';
import Categories from '../components/home/Categories';
import WhyGSM from '../components/home/WhyGSM';
import homeHero from '../assets/images/hero/home.png';

const Home = () => {
  return (
    <div>
      <SEO 
        title="Grace Super Market | Leading Retail Chain in Chennai"
        description="Shop at Grace Super Market for fresh groceries, quality products, and excellent service. Visit our 39 stores across Chennai for the best shopping experience."
        keywords="Grace Super Market, Chennai supermarket, grocery store, retail chain, fresh produce"
        ogImage={homeHero}
        canonicalUrl={process.env.REACT_APP_CURRENT_URL}
      />
      <HeroSection image={homeHero} />
      <div className="container px-6 md:px-20">
        <Features />
        <About />
      </div>
      <Categories />
      <WhyGSM />
    </div>
  );
};

export default Home;